<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  mounted() {},
  methods: {
    // Window scroll method
    windowScroll() {
      const navbar = document.getElementById("navbar");
      const title = document.getElementById("color-title");
      if (document.body.scrollTop >= 50 || document.documentElement.scrollTop >= 50) {
        navbar.classList.add("nav-sticky");
        title.classList.add("font-color-black");
      } else {
        navbar.classList.remove("nav-sticky");
        title.classList.remove("font-color-black");
      }
    },
    // Toggle menu
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
  },
};
</script>

<template>
  <div style="overflow-x: hidden">
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
      <div class="container">
        <a class="navbar-logo" href="javascript: void(0);">
          <img
            src="@/assets/images/name-logo.png"
            alt
            height="40"
            class="logo logo-dark"
          />
          <img
            src="@/assets/images/white-name-logo.png"
            alt
            height="40"
            class="logo logo-light"
          />
        </a>

        <button
          type="button"
          class="btn btn-sm px-3 font-size-16 d-lg-none header-item"
          data-toggle="collapse"
          data-target="#topnav-menu-content"
          @click="toggleMenu()"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>

        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul
            class="navbar-nav ms-auto"
            id="topnav-menu"
            v-scroll-spy-active="{ selector: 'a.nav-link' }"
          >
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#home'" href="javascript: void(0);"
                >الرئيسية</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#features'" href="javascript: void(0);"
                >شؤون الفرق و المنظمات</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#about'" href="javascript: void(0);"
                >من نحن</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" v-scroll-to="'#contact'" href="javascript: void(0);"
                >اتصل بنا</a
              >
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div v-scroll-spy>
      <div class="header" id="home">
        <!--Content -->
        <div class="container d-grid align-items-center main-header-content">
          <div class="row align-items-center">
            <div class="col-md-12 col-lg-6">
              <div class="text-white">
                <h1 class="text-white mb-3 main-title">مركز العمل التطوعي</h1>
                <p class="secondary-title">
                  يمكن للفرق و المنظمات العاملة في العراق الحصول على إجازة رسمية لمزاولة
                  العمل التطوعي بعد إستيفاء الشروط القانونية اللازمة.
                </p>
                <a href="/volunteer-works-center/volunteer-name-team" class="btn-record"
                  >إجازة عمل الفرق و المنظمات</a
                >
              </div>
            </div>
            <div class="col-md-12 col-lg-6 ms-lg-auto">
              <div class="box1">
                <img class="img-home" src="@/assets/images/home/home.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>

        <!--Waves-->
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 24 150 28"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
            />
          </defs>
          <g class="parallax">
            <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
            <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
            <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
            <use xlink:href="#gentle-wave" x="48" y="8" fill="#f8f8fb" />
          </g>
        </svg>
        <!--Waves end-->
      </div>
      <!-- end header -->

      <!-- Features start -->
      <section class="section pb-sm-5 pb-2" id="features">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="text-center">
                <h5><div class="small-title">شؤون الفرق و المنظمات</div></h5>
                <h4>شارك معنا في مركز العمل التطوعي</h4>
              </div>
            </div>
          </div>

          <div class="row align-items-center mt-5">
            <div class="col-md-6">
              <div class="c-services__item">
                <h3>تسجيل المتطوعين في مركز العمل التطوعي</h3>
                <p class="">
                  هذه الاستمارة خاصة بالمواطنين الذي يقدمون خدمات تطوعية مجانية ضمن
                  الانشطة التي ترعاها هيئة الحشد الشعبي لخدمة المجتمع او الانشطة التي يقوم
                  بها الافراد لخدمة بلدهم.
                </p>
                <a
                  href="/volunteer-works-center/volunteer-center"
                  rel="noopener noreferrer"
                  >انتقل</a
                >
              </div>
            </div>
            <div class="col-md-6">
              <div class="c-services__item">
                <h3>الدعم التطوعي</h3>
                <p class="">
                  يوفر المركز الدعم اللازم لنجاح البرامج و الانشطة التطوعية التي لها
                  أولوية في خطة المركز لهذا يرجى ملء الاستمارة الخاصة بإنشطتكم التطوعية
                  قبل شهر لغرض توفير الدعم اللازم لمبادراتكم وانشطتكم.
                </p>
                <a
                  href="/volunteer-works-center/volunteer-activities"
                  rel="noopener noreferrer"
                  >انتقل</a
                >
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Features end -->

      <!-- Features start -->
      <section class="section about_us mt-0 mt-sm-5" id="about">
        <img class="image-bg" src="@/assets/images/gg.png" alt="" />
        <div class="container">
          <div class="row justify-content-between align-items-center">
            <div class="col-lg-12">
              <div class="about_us_text">
                <h2>مركز العمل التطوعي</h2>
                <h3>من نحن ؟</h3>
                <p>
                  مركز العمل التطوعي في الحشد الشعبي هو أحد مؤسسات هيئة الحشد الشعبي الذي
                  يعنى بالعمل التطوعي بكافة أنواعه ويعمل على توفير بيئة مناسبة لتنمية
                  العمل التطوعي , وكما ان الحشد الشعبي كان ولا زال حاضرا في ميادين الدفاع
                  والمؤازرة للدولة والمجتمع، انطلقت رؤيته في تعميق روح العمل التطوعي
                  بأعتباره قيمة مجتمعية لبناء المواطن الصالح ودعامة بارزة لتنمية المجتمع،
                  حيث ان التركيز على العمل التطوعي جاء من اهمية هذا الجانب وكمايلي:
                </p>
              </div>
            </div>
            <div class="col-lg-6 order-2 order-lg-1">
              <img class="image-about" src="@/assets/images/home/about.jpg" alt="about" />
            </div>
            <div class="col-lg-6 order-1 order-lg-2">
              <ol class="list-ol">
                <li>
                  <p>
                    ان الحشد الشعبي تجربة شعبية اجتماعية تشكلت بدوافع تطوعية من خيار
                    الشباب العراقي المتحمس، وتحديدا بكلمة المرجعية التي دعت الى ذلك "عليهم
                    التطوع"وهذا يدعو الى الاهتمام بالعمل التطوعي كونه وسيلة اجتماعية خدمية
                    تهدف للمواطنة الصالحة والدفاع عن حرمات العراق.
                  </p>
                </li>
                <li>
                  <p>
                    دعوة الشهيد ابومهدي المهندس رضوان الله عليه عن يكون الحشد الشعبي مليون
                    بصبغة شعبية غير رسمية ويمثل قوة وطنية اجتماعية.
                  </p>
                </li>
                <li>
                  <p>
                    استمرارية الزخم المعنوي يولد حاضنة متميزة للحفاظ على مسيرة الحشد
                    الشعبي ونماء هذه التجربة،مع وجود ارضية خصبة للعمل والعطاء والتنمية
                    ممايدعو لانشاء مؤسسة تساهم في تطوير العمل الاجتماعي.
                  </p>
                </li>
                <li>
                  <p>
                    المجموعات التي دعمت الحشد ايام حربه المشروعة على داعش بالمال والاعلام
                    والغذاء وغيره من الدعم المعنوي والذي كان شريكا بالنصر،واخذ ذلك بنظر
                    الاعتبار لتسليط الضوء والاهتمام بعذه التجربة.
                  </p>
                </li>
                <li>
                  <p>
                    التمكين الاجتماعي في مشاركة المواطنين في ادارة الاوضاع الاجتماعية من
                    البرامج والمشاريع والانشطة في مختلف القطاعات.
                  </p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <!-- Features end -->

      <!-- Features start -->
      <section class="section pattern-bg mt-1">
        <div class="elementor-background-overlay"></div>
        <div class="container">
          <div class="row justify-content-center">
            <div class="col-md-12">
              <h2>" وَمَنْ تَطَوَّعَ خَيْرًا فَإِنَّ اللهَ شَاكِرٌ عَلِيمٌ "</h2>
              <span>البقرة : 158</span>
            </div>
          </div>
        </div>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1000 100"
          preserveAspectRatio="none"
        >
          <path
            class="elementor-shape-fill"
            opacity="0.33"
            d="M473,67.3c-203.9,88.3-263.1-34-320.3,0C66,119.1,0,59.7,0,59.7V0h1000v59.7 c0,0-62.1,26.1-94.9,29.3c-32.8,3.3-62.8-12.3-75.8-22.1C806,49.6,745.3,8.7,694.9,4.7S492.4,59,473,67.3z"
          ></path>
          <path
            class="elementor-shape-fill"
            opacity="0.66"
            d="M734,67.3c-45.5,0-77.2-23.2-129.1-39.1c-28.6-8.7-150.3-10.1-254,39.1 s-91.7-34.4-149.2,0C115.7,118.3,0,39.8,0,39.8V0h1000v36.5c0,0-28.2-18.5-92.1-18.5C810.2,18.1,775.7,67.3,734,67.3z"
          ></path>
          <path
            class="elementor-shape-fill"
            d="M766.1,28.9c-200-57.5-266,65.5-395.1,19.5C242,1.8,242,5.4,184.8,20.6C128,35.8,132.3,44.9,89.9,52.5C28.6,63.7,0,0,0,0 h1000c0,0-9.9,40.9-83.6,48.1S829.6,47,766.1,28.9z"
          ></path>
        </svg>
      </section>
      <!-- Features end -->

      <!-- Features start -->
      <section class="section section-ol">
        <div class="container">
          <div class="row">
            <div class="col-md-6 mb-5 mb-md-0">
              <h2>الاهداف</h2>
              <ol class="list-ol">
                <li>
                  <p>خلق بيئة تشاركية مجتمعية للعمل التطوعي.</p>
                </li>
                <li>
                  <p>تشجيع العمل بالفرق والمجموعات المجتمعية المحلية.</p>
                </li>
                <li>
                  <p>بناء تنظيم مجتمعي في ابراز دور الكفاءات والنخب بفرق تطوعية.</p>
                </li>
                <li>
                  <p>تنمية المجتمع المحلي والتدريب على بناء قدراته.</p>
                </li>
                <li>
                  <p>ادارة وتوجية فرق العمل التطوعية.</p>
                </li>
                <li>
                  <p>العمل على زيادة الوعي والاهتمام والنشاط التطوعي في البلاد.</p>
                </li>
              </ol>
            </div>
            <div class="col-md-6">
              <h2>السياسات</h2>
              <ol class="list-ol">
                <li>
                  <p>استحداث وحدات تنظيمية للعمل التطوعي في تشكيلات الحشد الشعبي كافة.</p>
                </li>
                <li>
                  <p>فتح نقاط عمل تطوعي في المحافظات ضمن مقر الهيئة.</p>
                </li>
                <li>
                  <p>منح خدمات التسجيل والانشاء للعمل التطوعي بعد استيفاء شروط المركز.</p>
                </li>
                <li>
                  <p>
                    تقديم التسهيلات الامنية واللوجستية للفرق التطوعية ضمن مجموعة معايير.
                  </p>
                </li>
                <li>
                  <p>يخضع كافة الفرق والانشطة التطوعية لبرنامج المركز التدريبي.</p>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <!-- Features end -->

      <!-- Footer start -->
      <footer class="landing-footer" id="contact">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="con-menu-footer">
                <img src="@/assets/images/white-logo.png" alt height="25" />
                <h5 class="mx-4">مركز العمل التطوعي</h5>
                <div class="p-about">
                  <p>
                    مركز العمل التطوعي في الحشد الشعبي هو أحد مؤسسات هيئة الحشد الشعبي
                    الذي يعنى بالعمل التطوعي بكافة أنواعه ويعمل على توفير بيئة مناسبة
                    لتنمية العمل التطوعي
                  </p>
                </div>
                <!-- <p class="mt-1">{{ new Date().getFullYear() }} © جميع الحقوق محفوظة</p> -->
              </div>
            </div>
            <div class="col-md-4">
              <div class="con-menu-footer">
                <h5>روابط سريعة</h5>
                <ul class="menu-footer">
                  <li>
                    <i class="bx bx-chevrons-left"></i>
                    <a v-scroll-to="'#home'" href="javascript: void(0);">الرئيسية</a>
                  </li>
                  <!-- <li class="nav-item">
                    <i class="bx bx-chevrons-left"></i>
                    <a href="/volunteer-works-center/volunteer-name-team">تسجيل</a>
                  </li> -->
                  <li>
                    <i class="bx bx-chevrons-left"></i>
                    <a v-scroll-to="'#features'" href="javascript: void(0);"
                      >شؤون الفرق و المنظمات</a
                    >
                  </li>
                  <li>
                    <i class="bx bx-chevrons-left"></i>
                    <a v-scroll-to="'#about'" href="javascript: void(0);">من نحن</a>
                  </li>
                  <li>
                    <i class="bx bx-chevrons-left"></i>
                    <a v-scroll-to="'#contact'" href="javascript: void(0);">اتصل بنا</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-4">
              <div class="con-menu-footer">
                <h5>اتصل بنا</h5>
                <ul class="menu-footer">
                  <li>
                    <div class="icon-callus"><i class="bx bxs-phone"></i></div>
                    <div class="p-callus">
                      <span>رقم الهاتف</span>
                      <span>07772225487</span>
                    </div>
                  </li>
                  <li>
                    <div class="icon-callus">
                      <i class="bx bx-envelope"></i>
                    </div>
                    <div class="p-callus">
                      <span>البريد الالكتروني</span>
                      <span>volunteer.work.center@gmail.com</span>
                    </div>
                  </li>
                  <li>
                    <div class="icon-callus"><i class="bx bxl-telegram"></i></div>
                    <div class="p-callus">
                      <span>معرف التلكرام</span>
                      <span>@V_work_BOT</span>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div class="copy-right">
                <span class="mt-1"
                  >{{ new Date().getFullYear() }} © جميع الحقوق محفوظة</span
                >
              </div>
            </div>
          </div>
        </div>
      </footer>
      <!-- Footer end -->
    </div>
  </div>
</template>
